export default {
  hero: {
    titlePre: 'We are',
    titleExpert: 'experts',
    titleMid: 'in',
    titleHighlight: 'interoperability and automation',
    titlePost: 'of strategic processes',
    propositionPre: 'We deliver',
    propositionHighlight: 'high-impact',
    propositionPost: 'solutions in a short time',
    ctaSolutions: 'Discover our solutions',
    ctaTalk: 'Talk to us',
  },
  productsSection: {
    titlePre: 'GPAX',
    titleHighlight: 'Solutions',
    subtitle: 'A complete platform for the digital transformation of your company',
    learnMore: 'Tell me more',
    saasPre: 'All our products can be subscribed in our',
    saasHighlight: 'SaaS',
    builder: {
      tagline: 'Innovation without limits',
      description: 'Innovate by interoperating with the systems you already use. Connect, integrate and automate your existing applications without replacing them.',
      feature1: 'Fast integration',
      feature2: 'No system replacement',
      feature3: 'Smart automation',
    },
    transformer: {
      tagline: 'Digital transformation',
      description: 'Transform and optimize your business processes with cutting-edge technology. Modernize your technology infrastructure.',
      feature1: 'Modernization',
      feature2: 'Optimization',
      feature3: 'Scalability',
    },
    audit: {
      tagline: 'Real-time control',
      description: 'Manage and run audit tasks in real time. Monitor, control and ensure compliance of your critical processes.',
      feature1: 'Real-time auditing',
      feature2: 'Full traceability',
      feature3: 'Regulatory compliance',
    },
  },
  credentials: {
    yearsValue: '20+',
    yearsLabel: 'Years innovating',
    yearsSub: 'in Latin America',
    isoValue: 'ISO 27001',
    isoLabel: 'Certified',
    isoSub: 'Information security',
    carbonValue: 'Carbon Neutral',
    carbonLabel: 'Certified',
    carbonSub: 'Environmental commitment',
  },
  commitment: {
    titlePre: 'Our',
    titleHighlight: 'Commitment',
    textPre: 'We deliver',
    textHighlight: 'high-impact solutions',
    textPost: 'in a short time',
    speedTitle: 'Speed',
    speedDesc: 'Agile and effective implementation',
    impactTitle: 'Impact',
    impactDesc: 'Measurable and tangible results',
    supportTitle: 'Support',
    supportDesc: 'Continuous guidance',
    cta: 'Learn more about us',
  },
  clients: {
    titlePre: 'They trust',
    titleHighlight: 'Infoware S. A.',
    subtitle: 'Leading companies that transform their processes with our solutions',
    dotLabel: 'Go to slide',
  },
  platformBenefits: {
    titlePre: 'Advantages of our',
    titleHighlight: 'Platform',
    subtitle: 'A robust and reliable infrastructure for your critical applications',
    scalabilityTitle: 'Scalability',
    scalabilityDesc: 'Management of different server types and schemes. Grow or adapt to the volume of applications and users, achieving high scalability.',
    scalabilityFeature1: 'Flexible architecture',
    scalabilityFeature2: 'Limitless growth',
    scalabilityFeature3: 'Resource optimization',
    securityTitle: 'Security',
    securityDesc: 'Bank-level SSL-EV certificate (green certificate), used by banking institutions so their customers can carry out secure transactions over the Internet.',
    securityFeature1: 'SSL-EV certificate',
    securityFeature2: 'Bank level',
    securityFeature3: 'Secure transactions',
    monitoringTitle: 'Monitoring',
    monitoringDesc: 'A third-party service (Site24x7) provides real-time online statistics, with historical records as required.',
    monitoringFeature1: '24/7 monitoring',
    monitoringFeature2: 'Real-time statistics',
    monitoringFeature3: 'Historical records',
    more: 'More information about our infrastructure',
  },
  cta: {
    titlePre: 'Ready to',
    titleHighlight: 'transform',
    titlePost: 'your company?',
    subtitle: 'Contact us today and discover how our solutions can boost your business',
    whatsapp: 'Talk to us on WhatsApp',
    email: 'Send us an email',
    phone: 'Phone',
    emailLabel: 'Email',
  },
};